import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";
import PublicLayout from "@/layouts/PublicLayout";
import { useDocumentTitle } from "@/lib/useDocumentTitle";

export default function PaymentCancelPage() {
  useDocumentTitle("Payment canceled");
  return (
    <PublicLayout>
      <div className="mx-auto max-w-lg px-6 py-24 text-center" data-testid="payment-cancel-page">
        <div className="mx-auto h-16 w-16 rounded-full bg-slate-100 flex items-center justify-center">
          <XCircle className="h-8 w-8 text-[#252A34]/60" />
        </div>
        <div className="mt-5 font-display text-3xl font-semibold text-[#071b22]">No charge — you're good.</div>
        <div className="text-sm text-[#252A34]/70 mt-2">Payment was canceled before completion. You can try again anytime.</div>
        <div className="mt-8 flex items-center justify-center gap-3">
          <Link to="/dashboard/bookings" className="rounded-full border border-slate-200 px-5 py-2.5 text-sm font-medium inline-flex items-center gap-2 hover:bg-slate-50"><ArrowLeft className="h-4 w-4" /> Back to bookings</Link>
          <Link to="/dashboard" className="rounded-full bg-[#165a71] text-white px-5 py-2.5 text-sm font-medium hover:bg-[#11485a]">Go to dashboard</Link>
        </div>
      </div>
    </PublicLayout>
  );
}
